import { Config } from '../config';
import { UserService } from './User';

export const WithdrawService = {
  /**
 * [HISTORY]
 * @param {object} data
 * @param {string} data.beginDate
 * @param {string} data.endDate
 * @param {string} data.status
 */
  History(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return WithdrawService.Common.Fetch(Config.service.withdraw.history, requestOptions);
  },
  /**
* [DETAIL]
* @param {object} transactionId
*/
  Detail(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return WithdrawService.Common.Fetch(Config.service.withdraw.detail, requestOptions);
  },
  SaveComment(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return WithdrawService.Common.Fetch(Config.service.withdraw.saveComment, requestOptions);
  },
  /**
    * [CONFIRM]
    * @param {string} transactionId
    * @param {string} type
    */
  Confirm(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return WithdrawService.Common.Fetch(Config.service.actions.confirm, requestOptions);
  },
  /**
    * [CANCEL]
    * @param {string} transactionId
    * @param {string} type
    */
  Cancel(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return WithdrawService.Common.Fetch(Config.service.actions.cancel, requestOptions);
  },
  /**
    * [PENDING]
    * @param {string} transactionId
    * @param {string} type
    */
  Pending(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return WithdrawService.Common.Fetch(Config.service.actions.pending, requestOptions);
  },
  /**
 * [COMMON]
 * @function Fetch
 */
  Common: {
    Fetch(url, requestOptions) {
      return fetch(url, requestOptions)
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          if (response.status === 401) {
            UserService.Logout();
            window.location.reload();
          } else {
            throw new Error();
          }
          return false;
        })
        .then(json => json)
        .catch(() => false);
    },
  },
};
